import { SxProps } from '@mui/material'

import theme from '../../../../shared/styles/themes/default.theme'

const styles = {
  divider: {
    margin: theme.spacing(2, 0)
  } as SxProps,

  container: {
    display: 'flex',
    flexDirection: 'column',
    gap: theme.spacing(2),
    padding: theme.spacing(2),
    border: `1px solid ${theme.palette.grey[200]}`,
    // // backgroundColor: theme.palette.grey[50],
    borderRadius: theme.spacing(2),
    marginBottom: theme.spacing(4)
  } as SxProps
}

export default styles
